// extracted by mini-css-extract-plugin
module.exports = {"linksWrapper":"CategoryLinks_linksWrapper__Bu2Jp","categoryLink":"CategoryLinks_categoryLink__4Pi8H"};